<template>
  <user-center-wrap>
		<div class="history">
		  <div class="header">竞猜历史</div>
			<BetHistory></BetHistory>
		</div>
	</user-center-wrap>
</template>

<script>
import UserCenterWrap from "../../../components/user-center-wrap/user-center-wrap";
import { post } from "../../../util/http";
import { mapState, mapMutations, mapActions } from "vuex";
import BetHistory from "@/components/guessing/betlist"
export default {
  name: "betHistory",
  components: {
    UserCenterWrap,
		BetHistory
  },
  data() {
    return {

    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  mounted() {
    
  },
  methods: {
    
  }
};
</script>

<style scoped lang="scss">
.history {
  width: 100%;
  height: 100%;
  padding: 0.28rem 0.44rem;
	.header {
	  font-size: 0.2rem;
	  color: #333333;
	  font-weight: 500;
	  margin-bottom: 0.4rem;
	}
}

</style>
